<script>
import { mapState, mapActions, mapMutations } from 'vuex';

import { IRI } from '@/api';

export default {
  name: 'ModuleCodesEdition',
  computed: {
    ...mapState('course/collection', {
      courses: 'items',
    }),
    ...mapState('tag/collection', {
      tags: 'items',
    }),
    ...mapState('code/item', [
      'item',
    ]),
    course: {
      get () {
        if (!this.item.course) {
          return '';
        }
        return this.item.course.replace(IRI.course, '');
      },
      set (value) {
        const { item } = this;
        item.course = `${IRI.course}${value}`;
        this.setItem(item);
      },
    },
    tag: {
      get () {
        if (!this.item.tag) {
          return '';
        }
        return this.item.tag.replace(IRI.tag, '');
      },
      set (value) {
        const { item } = this;
        item.tag = `${IRI.tag}${value}`;
        this.setItem(item);
      },
    },
    code: {
      get () {
        return this.item.code;
      },
      set (value) {
        const { item } = this;
        item.code = value;
        this.setItem(item);
      },
  },
  days: {
    get () {
      return this.item.days || '';
    },
    set (value) {
      const { item } = this;
      item.days = parseInt(value);
      this.setItem(item);
      },
    },
  },
  methods: {
    ...mapActions('course/collection', {
      fetchCourses: 'fetch',
    }),
    ...mapActions('tag/collection', {
      fetchTags: 'fetch',
    }),
    ...mapActions('code/item', [
      'save',
      'fetch',
    ]),
    ...mapMutations('code/item', [
      'setItem',
      'reset',
    ]),
    localSave () {
      const payload = Object.assign({}, this.item);

      this.save(payload)
        .then(() => {
          if (payload.id) {
            return;
          }

          this.$router.push({ name: 'codes-listing' });
        })
      ;
    },
  },
  created() {
    const { id } = this.$route.params;
    this.fetchCourses(false);
    this.fetchTags();

    if (!id) {
      this.reset();
      return;
    }

    this.fetch(id);
  },
};
</script>
<template>
  <div class="box">
    <h2>General</h2>
    <div class="form-group mt-3">
      <label for="course" class="d-block">Course</label>
      <select id="course" class="form-control rounded-0" v-model="course">
        <option value="" disabled>Select a Course</option>
        <option v-for="course in courses" :key="course.id" :value="course.id">{{ course.title }}</option>
      </select>
    </div>
    <div class="form-group mt-3">
      <label for="tag" class="d-block">Tag</label>
      <select id="tag" class="form-control rounded-0" v-model="tag">
        <option value="" disabled>Select a Tag</option>
        <option v-for="tag in tags" :key="tag.id" :value="tag.id">{{ tag.name }}</option>
      </select>
    </div>
    <div class="form-group mt-3">
      <label for="code" class="d-block">Code</label>
      <input id="code" class="form-control rounded-0" v-model="code" />
    </div>
    <div class="form-group mt-3">
      <label for="days" class="d-block">Days</label>
      <input id="days" type="number" min="0" max="365" class="form-control rounded-0" v-model="days" />
    </div>
    <div class="form-group mt-3 text-right">
      <button class="btn btn-primary" @click="localSave">Save</button>
    </div>
  </div>
</template>
